import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavigationService } from '../navigation.service';

@Component({
  selector: 'menu-button',
  templateUrl: './menu-button.component.html',
  styleUrls: ['./menu-button.component.scss']
})
export class MenuButtonComponent implements OnInit {
  @Input() iconName: string = 'menu';
  constructor(
    private navigation: NavigationService
  ) { 

  }

  ngOnInit(): void {

  }

  onClick() {
    this.navigation.toggle();
  }

}
